import React from "react";
import "./Skills.css";
import Html from "./html.png";
import Css from "./css.png";
import Bootstrap from "./bootstrap.png";
import Sass from "./sass.png";
import Js from "./js.png";
import ReactLogo from "./logo192.png";
import Vue from "./vue.png";
import Node from "./nodejs.png";
import Python from "./python.png";
import Sql from "./sql.png";
import Mongo from "./mongodb.png";
import Photoshop from "./photoshop.png";
import Lightroom from "./lightroom.png";
import Git from "./git.png";
import Github from "./github.png";
import wp from "./wordpress.png";

function Skills() {
  return (
    <div className="container">
      <section className="skills">
        <div>
          <img className="skill-img" src={Html} alt="HTML5" />
          <img className="skill-img" src={Css} alt="CSS3" />
          <img className="skill-img" src={Bootstrap} alt="Bootstrap" />
          <img className="skill-img" src={Sass} alt="Sass" />
          <img className="skill-img" src={Js} alt="Javascript" />
          <img className="skill-img" src={ReactLogo} alt="React" />
          <img className="skill-img" src={Vue} alt="Vue" />
          <img className="skill-img" src={wp} alt="Wordpress" />
        </div>
      </section>
      <section className="skills">
        <div>
          <img className="skill-img" src={Node} alt="NodeJs" />
          <img className="skill-img" src={Python} alt="Python" />
          <img className="skill-img" src={Sql} alt="sql" />
          <img className="skill-img" src={Mongo} alt="MongoDb" />
          <img className="skill-img" src={Git} alt="Git" />
          <img className="skill-img" src={Github} alt="Gitthub" />
        </div>
      </section>
      <section className="skills">
        <div>
          <img className="skill-img" src={Photoshop} alt="Photoshop" />
          <img className="skill-img" src={Lightroom} alt="Lightroom" />
        </div>
      </section>
    </div>
  );
}

export default Skills;
